import { useState } from 'react'
import { maskCNPJInput, validateCNPJ } from '../utils/cnpj'
import { useNavigate } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, FormActions, FormSection, Input, PageHeader } from '../components/ui'

const empty = {
  tenant_id: '',
  cnpj: '',
  corporate_name: '',
  trading_name: '',
  representative_name: '',
  representative_cpf: '',
  representative_email: '',
  admin_email: '',
  admin_password: '',
}

export default function RevendaForm() {
  const navigate = useNavigate()
  const [form, setForm] = useState(empty)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const update = (field, value) => setForm((current) => ({ ...current, [field]: value }))

  async function submit(event) {
    event.preventDefault()
    if (saving) return
    if (form.cnpj?.trim() && !validateCNPJ(form.cnpj)) {
      setError('CNPJ inválido.')
      return
    }
    setSaving(true)
    setError('')
    try {
      await adminApi.createRevenda(form)
      navigate('/revendas', { replace: true, state: { message: 'Revenda criada com sucesso.' } })
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setSaving(false)
    }
  }

  return (
    <form onSubmit={submit} className="space-y-6">
      <PageHeader eyebrow="Parceiros" title="Nova revenda" description="Cadastre a organização parceira, seu representante e o acesso administrativo." icon="fa-handshake" />
      {error && <Alert type="error">{error}</Alert>}

      <FormSection title="Dados da revenda" description="Identificação fiscal e comercial." icon="fa-briefcase">
        <div className="grid gap-4 md:grid-cols-2">
          <Input label="Tenant ID *" value={form.tenant_id} onChange={(e) => update('tenant_id', e.target.value)} required autoFocus />
          <Input label="CNPJ *" value={form.cnpj} onChange={(e) => update('cnpj', maskCNPJInput(e.target.value))} required className="uppercase" placeholder="00.000.000/0001-00 ou 12.ABC.345/01DE-35" />
          <Input label="Razão social *" value={form.corporate_name} onChange={(e) => update('corporate_name', e.target.value)} required />
          <Input label="Nome fantasia" value={form.trading_name} onChange={(e) => update('trading_name', e.target.value)} />
        </div>
      </FormSection>

      <FormSection title="Representante legal" description="Pessoa responsável pelo relacionamento com a revenda." icon="fa-address-card">
        <div className="grid gap-4 md:grid-cols-2">
          <Input label="Nome do representante *" value={form.representative_name} onChange={(e) => update('representative_name', e.target.value)} required />
          <Input label="CPF do representante *" value={form.representative_cpf} onChange={(e) => update('representative_cpf', e.target.value)} required />
          <Input label="E-mail do representante *" type="email" value={form.representative_email} onChange={(e) => update('representative_email', e.target.value)} required />
        </div>
      </FormSection>

      <FormSection title="Acesso administrativo" description="Credenciais iniciais para administração das bases vinculadas." icon="fa-user-lock">
        <div className="grid gap-4 md:grid-cols-2">
          <Input label="E-mail do administrador *" type="email" value={form.admin_email} onChange={(e) => update('admin_email', e.target.value)} required />
          <Input label="Senha inicial *" type="password" autoComplete="new-password" value={form.admin_password} onChange={(e) => update('admin_password', e.target.value)} required />
        </div>
      </FormSection>

      <FormActions onCancel={() => navigate('/revendas')} saving={saving} submitLabel="Criar revenda" />
    </form>
  )
}
